import { getFormattedTime } from '@wix/live-video-commons';
import React, { useState, useEffect } from 'react';
var format = function (lang, value, unit, date) {
    try {
        var intl = new Intl.RelativeTimeFormat(lang || 'en', { style: 'narrow' });
        return intl.format(value, unit);
    }
    catch (e) {
        return getFormattedTime({ locale: lang, timestamp: date });
    }
};
export var MessageTime = function (_a) {
    var date = _a.date, justNowText = _a.justNowText, lang = _a.lang;
    var _b = useState(), text = _b[0], setText = _b[1];
    var updateText = function () {
        var ms = Number(Date.now()) - Number(date);
        var s = Math.floor(ms / 1000);
        var m = Math.floor(s / 60);
        var h = Math.floor(m / 60);
        var d = Math.floor(h / 24);
        var w = Math.floor(d / 7);
        if (w) {
            setText(format(lang, -w, 'week', date));
        }
        else if (d) {
            setText(format(lang, -d, 'day', date));
        }
        else if (h) {
            setText(format(lang, -h, 'hour', date));
        }
        else if (m) {
            setText(format(lang, -m, 'minute', date));
        }
        else {
            setText(justNowText);
        }
    };
    useEffect(function () {
        updateText();
        var interval = setInterval(updateText, 60000);
        return function () {
            clearInterval(interval);
        };
    }, []);
    return React.createElement(React.Fragment, null, text);
};
//# sourceMappingURL=message-time.js.map